import en from "@/localization/en.json";
import { phoneRegex } from "@/utils/patterns";
import * as Yup from "yup";

export const signInWithEmailSchema = Yup.object({
  email: Yup.string().email().required(),
  password: Yup.string().required().min(8).max(25),
});

export const signInWithOtpSchema = Yup.object({
  phone: Yup.string()
    .required()
    .matches(phoneRegex, en["signup.invalid_phone_number"]),
});

export const signUpWithEmailSchema = Yup.object({
  name: Yup.string().required().max(20).min(3),
  email: Yup.string().email().required(),
});

export const signUpWithOtpSchema = Yup.object({
  name: Yup.string().required().max(20).min(3),
  phone: Yup.string()
    .required()
    .matches(phoneRegex, en["signup.invalid_phone_number"]),
});

export const updatePasswordSchema = Yup.object({
  password: Yup.string().required().min(8).max(25),
  confirmPassword: Yup.string()
    .required(en["confirmPasswordValidation.confirmPassword.required"])
    .oneOf(
      [Yup.ref("password"), null],
      en["forgetPassword.password_confirmation"]
    ),
});

export const forgetPasswordSchema = Yup.object({
  email: Yup.string().email().required(),
});

export const changePasswordSchema = Yup.object({
  current_password: Yup.string().required(
    en["changePasswordValidation.currentPassword.required"]
  ),
  new_password: Yup.string()
    .required(en["changePasswordValidation.newPassword.required"])
    .min(8, en["changePasswordValidation.newPassword.minLength"])
    .max(25, en["changePasswordValidation.newPassword.maxLength"]),

  new_password_confirmation: Yup.string()
    .required(en["changePasswordValidation.confirmNewPassword.required"])
    .oneOf(
      [Yup.ref("new_password"), null],
      en["forgetPassword.password_confirmation"]
    ),
});

export const signUpWithPhoneSchema = Yup.object({
  full_name: Yup.string()
    .required("Full name is a required field")
    .max(30, "Full name must be at most 30 characters")
    .min(3, "Full name must be at least 3 characters"),
  email: Yup.string()
    .email("Email address must be a valid email")
    .required("Email address is a required field"),
});
